export const maxText = 'is too long';
export const alphabetWithHypenRegex = /^[a-zA-Z\- ]+$/;
export const alphabetNumberWithHypenRegex = /^[a-zA-Z0-9\- ]+$/;
export const alphabetNumberRegex = /^[a-zA-Z0-9]+$/;
export const numberRegex = /^[0-9]+$/;
export const pswdRegex = /(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[`~!@#$%^&*()_\-+=?])([a-zA-Z0-9`~!@#$%^&*()_\-+=?]{8,20})/;
